import { FormValues } from "../types";
import { bffApi } from "../../../../services/bff/bffApi";
import {BaseService} from "../../../../global/classes";

export default class SlcPaymentService extends BaseService {
  getPayments = async (
    page:number,
    pageSize:number,
    filter?:FormValues
  )=> {
    const merchantId = this.selectedCompany?.merchantId ?? filter?.merchantId ?? null;
    const rangeStartReceiveDate = filter?.rangeStartReceiveDate || null;
    const rangeEndReceiveDate = filter?.rangeEndReceiveDate || null;
    const paymentType = filter?.paymentType || null;
    const paymentIdentifier = filter?.paymentIdentifier || null;
    const operationStatus = filter?.operationStatus ?? null;
    const brandCode = filter?.brandCode || null;
    const receiverType = filter?.receiverType || null;
    const sftpEnabled = filter?.sftpEnabled ?? null;

    try {
      const response = await bffApi.get(`/api/slc/v1/paymentdetail/payment-details`,
        {
          params: {
            merchantId,
            rangeStartReceiveDate,
            rangeEndReceiveDate,
            paymentType,
            paymentIdentifier,
            operationStatus,
            brandCode,
            receiverType,
            sftpEnabled,
            pageNumber: page,
            pageSize: pageSize
          },
        });

      return response.data;
    } catch (error) {
      throw error;
    }
  };

  getPaymentsXlsxDownload = async (
    filter?: FormValues
  ) => {
    const merchantId = this.selectedCompany?.merchantId ?? filter?.merchantId ?? null;
    const rangeStartReceiveDate = filter?.rangeStartReceiveDate || null;
    const rangeEndReceiveDate = filter?.rangeEndReceiveDate || null;
    const paymentType = filter?.paymentType || null;
    const paymentIdentifier = filter?.paymentIdentifier || null;
    const operationStatus = filter?.operationStatus ?? null;
    const brandCode = filter?.brandCode || null;
    const receiverType = filter?.receiverType || null;
    const sftpEnabled = filter?.sftpEnabled ?? null;

    try {
      const response = await bffApi.get(`/api/slc/v1/paymentdetail/payment-details/export`,
        {
          params: {
            merchantId,
            rangeStartReceiveDate,
            rangeEndReceiveDate,
            paymentType,
            paymentIdentifier,
            operationStatus,
            brandCode,
            receiverType,
            sftpEnabled
          },
          responseType: "blob"
        });

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  getPaymentsGroupedXlsxDownload = async (filter?: FormValues) => {
    const merchantId = this.selectedCompany?.merchantId ?? filter?.merchantId ?? null;
    const rangeStartReceiveDate = filter?.rangeStartReceiveDate || null;
    const rangeEndReceiveDate = filter?.rangeEndReceiveDate || null;
    const paymentIdentifier = filter?.paymentIdentifier || null;
    const paymentType = filter?.paymentType || null;
    const operationStatus = filter?.operationStatus ?? null;
    const brandCode = filter?.brandCode || null;
    const receiverType = filter?.receiverType || null;
    const sftpEnabled = filter?.sftpEnabled ?? null;

    const response = await bffApi.get(`/api/slc/v1/paymentdetail/payment-details-grouped/export`, {
      params: {
        merchantId,
        rangeStartReceiveDate,
        rangeEndReceiveDate,
        paymentIdentifier,
        paymentType,
        operationStatus,
        brandCode,
        receiverType,
        sftpEnabled
      },
      responseType: "blob",
    });

    return response.data;
  };

  getDepositPdf = async (id: number) => {
  const response = await bffApi.get(
    `/api/slc/v1/paymentdetail/get-depositos-pdf/${id}`,
    {
      responseType: "blob",
    }
  );

  return response.data;
};

}
